import {lazy, useEffect} from 'react';
import {Analytics} from '@chekin/shared';
import {useUIVariant} from 'hooks/useUIVariant';
import {useIsOffline} from 'hooks/useIsOffline';
import {REDESIGN_SURFACE_CLASS, UI_VARIANTS} from 'utils/uiVariant';
import {OfflineView} from 'pages/OfflineView';
import AppRouter from 'Routes';

const LegacyRouter = lazy(() => import('@legacy/LegacyRouter'));

function DesignSwitch() {
  const {variant, isResolved} = useUIVariant();
  const isOffline = useIsOffline();
  const isRedesign = variant === UI_VARIANTS.redesign;

  useEffect(() => {
    document.documentElement.classList.toggle(
      REDESIGN_SURFACE_CLASS,
      !isResolved || isRedesign,
    );
  }, [isResolved, isRedesign]);

  useEffect(() => {
    if (!isResolved) return;
    const appVariant = {app_variant: isRedesign ? 'redesign' : 'legacy'};
    Analytics.addEventProperties(appVariant);
    Analytics.addPersonProperties(appVariant);
  }, [isResolved, isRedesign]);

  if (!isResolved) {
    if (isOffline) {
      return <OfflineView />;
    }
    return null;
  }

  if (isRedesign) {
    return <AppRouter />;
  }

  return <LegacyRouter />;
}

export default DesignSwitch;
